let emptyTransektinfo = {
  transektFrassHase: false,
  transektFrassMaus: false,
  transektFrassBieber: false,
  transektKrautanteil: NaN,
};

export default emptyTransektinfo;
